<template>
    <KvColorInput
        v-bind="$attrs"
        v-on="$listeners"
        variant="outlined"
        size="large"
    />
</template>

<script>
import KvColorInput from "../../components/inputs/kv-color-input.vue";

export default {
    name: "BenefitsColorPicker",
    components: {
        KvColorInput,
    },
    inheritAttrs: false,
};
</script>
